var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsable"},[_c('h3',{on:{"click":function($event){_vm.active = !_vm.active}}},[_c('span',{class:_vm.active ? 'active' : ''}),_vm._v(" "),_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._v(" "),_c('p',{class:[_vm.active ? 'active' : '', _vm.loaded ? '' : 'preload'],style:(_vm.active ? 'max-height: ' + _vm.naturalHeight + 'px' : _vm.loaded ? 'max-height: 0' : '')},[_vm._t("content",function(){return [_vm._v(_vm._s(_vm.content))]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cf31574","hasScoped":true,"buble":{"transforms":{}}}!./src/components/collapsable/template.html
// module id = 1008
// module chunks = 0